import api_base from './base.js'


const api_events = {
  create: data => api_base(true).post('/actions/v1/events/', data),
}

export default api_events
